// extracted by mini-css-extract-plugin
module.exports = {"melodyVideo":"en-z","landingPageVideo":"fn-z","play":"gn-z","iframeVideo":"hn-z","playHidden":"in-z","fullwidth":"jn-z"};